/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, ButtonGroup, FormControlLabel, Modal, Popover } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import BellIcon from "assets/icons/BellIcon";
import { ReactNode, useEffect, useState } from "react";
import TableMenu from "../../../Table/TableMenu";
import PlusIcon from "assets/icons/PlusIcon";
import { IOSSwitch } from "components/Input/switch";
import CloseIcon from "assets/icons/CloseIcon";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import CalendarInput from "components/Input/CalendarInput";
import CustomCalendarInput from "components/Input/CustomCalenderInput";
import { PrintRounded } from "@mui/icons-material";

export interface ActionProps {
  actions?: any;
  withReminder?: boolean;
  reminderData?: any;
  side?: ReactNode;
  fireDate?: string;
  withPrint?: boolean
  submitNotification?: (value: any) => void;
  openModal?: any;
  handleOpenModal?: () => void;
  handleCloseModal?: () => void;
  deleteItem?: (id?: any) => void;
  updateNotification?: (active?: any) => void;
}

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 386,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 1.5,
  pt: 2,
  pb: 2,
  direction: "rtl",
};

export default function Action({
  withReminder,
  side,
  withPrint,
  actions,
  reminderData = [],
  fireDate,
  submitNotification,
  openModal,
  handleOpenModal,
  handleCloseModal,
  deleteItem,
  updateNotification,
}: ActionProps) {
  // const btns = [{ Icon: PrinterIcon }, { Icon: ExcelIcon }, { Icon: PdfIcon }];
  const [buttons, setButtons] = useState([]);
  // reminder state
  const [reminderDate, setReminderDate] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // ===reminder state

  useEffect(() => {
    //@ts-ignore
    setReminderDate(fireDate);
  }, [fireDate]);

  // reminder action
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  // ===reminder action

  // modal actions
  const [checked, setChecked] = useState(false);
  const [reminderTitle, setReminderTitle] = useState<string | number>("");
  const [reminderDescription, setReminderDescription] = useState<string | number>("");

  // ===modal actions

  useEffect(() => {
    if (actions && actions.icons) {
      setButtons(actions.icons);
    }
  }, []);
  useEffect(() => {
    if (fireDate === undefined) {
      setChecked(false);
    }
  }, [fireDate]);
  // const downloadTable = (type: any) => {
  //   if (type === "excel") {
  //     const data: any = [];
  //     dataTable.items.map((item: any) => {
  //       const row = {};
  //       activeTab?.tableColumns.map((title: any) => {
  //         (row as any)[title["name"]] = title.getValue ? title.getValue(item) : item[title["key"]];
  //       });
  //       data.push(row);
  //     });

  //     const worksheet = xlsx.utils.json_to_sheet(data);
  //     const workbook = xlsx.utils.book_new();
  //     xlsx.utils.book_append_sheet(workbook, worksheet, activeTab.pluralLabel ?? activeTab.label);
  //     //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
  //     //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
  //     xlsx.writeFile(workbook, `${activeTab.key.charAt(0).toUpperCase() + activeTab.key.slice(1)}.xlsx`);
  //   }
  // };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 32px",
      }}
    >
      {side}
      <div
        style={{
          direction: "ltr",
          display: "flex",
          alignItems: "center",
          gap: 16,
        }}
      >
        <TableMenu item={{}} actions={[]} items={actions.menu} />
        <div>
          <ButtonGroup style={{ backgroundColor: "#F5F9FF" }}>
            {
              //@ts-ignore
              buttons.map(({ Icon, onClick }: any, index: any) => (
                <Button
                  key={index}
                  style={{
                    borderColor: "#DCDFE8",
                    minWidth: 40,
                    minHeight: 40,
                    padding: 0,
                  }}
                  onClick={onClick}
                >
                  <Icon color="#ABBACC" />
                </Button>
              ))
            }
          </ButtonGroup>
        </div>
        {withReminder && (
          <>
            <Button
              style={{
                border: "1px solid #EBEFF5",
                minWidth: 40,
                // minHeight: 40,
                borderRadius: 8,
              }}
              onClick={handleClick}
            >
              <BellIcon style={{ color: "#95A3B5" }} />
            </Button>

            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              style={{ marginTop: 16 }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              PaperProps={{
                style: {
                  maxHeight: "600px",
                },
              }}
            >
              <div
                style={{
                  paddingTop: "16px",
                  paddingBottom: "4px",
                  minWidth: 350,
                  display: "flex",
                  flexDirection: "column",
                  direction: "rtl",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",

                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                  }}
                >
                  <span>یاد آور ها</span>
                  <Button
                    style={{
                      border: "1.4px solid #1062D0",
                      minWidth: 40,
                      // minHeight: 40,
                      borderRadius: 6,
                    }}
                    onClick={handleOpenModal}
                  >
                    <PlusIcon scale={0.7} />
                  </Button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 16,
                  }}
                >
                  {reminderData.map((item: any, index: any) => (
                    <CardItem
                      key={index}
                      active={item?.active || false}
                      date={item?.fireDate}
                      title={item?.title}
                      deleteItem={() => {
                        //@ts-ignore
                        deleteItem(item?.id);
                        // call delete api
                      }}
                      updateNotification={() => {
                        //@ts-ignore
                        updateNotification({
                          id: item?.id,
                          active: !item.active,
                        });
                      }}
                    />
                  ))}
                </div>
              </div>
            </Popover>
          </>
        )}
        {withPrint && (
          <Button
            style={{
              border: "1px solid #EBEFF5",
              minWidth: 40,
              // minHeight: 40,
              borderRadius: 8,
            }}
            onClick={() => {
              const btn = document.getElementById("toPrintTransAction")
              if (btn) btn.click()
            }}
          >
            <PrintRounded style={{ color: "#95A3B5" }} />
          </Button>
        )}
      </div>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>تنظیم یاد آور</span>

            <div
              onClick={handleCloseModal}
              style={{
                background: "#E3E4E5",
                borderRadius: "3px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloseIcon scale={0.4} />
            </div>
          </div>
          <div
            style={{
              paddingLeft: 5,
              paddingRight: 5,
            }}
          >
            <div style={{ marginTop: 36 }}>
              <BasicTextInput
                label="عنوان"
                style={{ minWidth: 300 }}
                val={reminderTitle}
                onChange={setReminderTitle}
              />
            </div>
            <div style={{ marginTop: 24 }}>
              <BasicTextInput
                textArea
                rows={5}
                label="متن یادآور"
                style={{ minWidth: 300 }}
                val={reminderDescription}
                onChange={setReminderDescription}
              />
            </div>
            <div
              style={{
                marginTop: "60px",
                display: "flex",
                alignItems: "flex-end",
                flexDirection: "row",
              }}
            >
              {fireDate && (
                <div>
                  <Checkbox
                    defaultChecked
                    checked={checked}
                    onClick={() => {
                      //@ts-ignore
                      setReminderDate(fireDate);
                      setChecked(!checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                    sx={{ color: "#1062D0" }}
                  />
                  <span style={{ fontSize: "14px", maxLines: "none" }}>يادآوری در موعد سررسید</span>
                </div>
              )}
              <div
                style={{
                  flex: 1,
                  marginRight: "24px",
                }}
              >
                <CustomCalendarInput
                  value={reminderDate}
                  disabled={checked}
                  label="تاریخ"
                  name={"date"}
                  stateLess
                  onChange={(val) => {
                    setReminderDate(val);
                  }}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "24px",
              width: "100%",
              gap: "10px",
              flexDirection: "row-reverse",
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                //@ts-ignore
                submitNotification({
                  title: reminderTitle,
                  description: reminderDescription,
                  fireDate: reminderDate,
                });
              }}
              style={{
                padding: "5px 40px",
              }}
            >
              <span>ثبت</span>
            </Button>
            <Button
              variant="outlined"
              color="disabled"
              onClick={() => {
                setReminderTitle("");
                setReminderDescription("");
                //@ts-ignore
                handleCloseModal();
              }}
              style={{
                padding: "5px 22px",
              }}
            >
              <span>لغو</span>
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

type CardItemProps = {
  title?: string;
  date?: string;
  active?: boolean;
  deleteItem?: () => void;
  updateNotification?: () => void;
};

const CardItem = ({
  deleteItem,
  title = "",
  date = "",
  active = true,
  updateNotification,
}: CardItemProps) => {
  const [hover, setHover] = useState(false);
  const [_switch, setSwitch] = useState(active);

  useEffect(() => {
    setSwitch(active);
  }, [active]);

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        padding: "10px 20px 10px 20px",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "row",
          width: "100%",
          minHeight: "84px",
          background: "#FEFEFE",
          borderRadius: "6px",
          boxShadow: "0px 0px 16px 4px rgba(26, 25, 25, 0.11)",
        }}
      >
        <div
          style={{
            width: "4px",
            height: "100%",
            backgroundColor: "#1062D0",
            borderRadius: "0px 6px 6px 0px",
          }}
        />
        <div
          style={{
            flex: 1,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "12px",
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <span
              style={{
                color: "#5B5B5C",
                fontSize: "14px",
              }}
            >
              {title}
            </span>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                color: "#8D8E8F",
                marginLeft: "12px",
              }}
            >
              {date}
            </span>
            <div
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  marginLeft: 12,
                  color: "#3E485B",
                  fontSize: "12px",
                }}
              >
                یادآور {_switch ? "فعال" : "غیرفعال"}
              </span>
              <IOSSwitch
                defaultChecked={_switch}
                onClick={() => {
                  //@ts-ignore
                  updateNotification();
                  setSwitch(!_switch);
                }}
                checked={_switch}
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
          </div>
        </div>
        <div
          onClick={deleteItem}
          style={{
            display: hover ? "block" : "none",
            borderRadius: 15,
            background: "#E3E4E5",
            position: "absolute",
            top: -8,
            left: -8,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CloseIcon scale={0.4} />
        </div>
      </div>
    </div>
  );
};
